import { InjectionToken } from '@angular/core';

export const WIZARD_HOME_ADDRESS_NEXT_STEP: InjectionToken<string> = new InjectionToken<string>('');
